import { GtmState } from './gtm.state';

export const ACTION_TYPES = {
  UPDATE_CONTAINER_ID: 'gtm/UPDATE_CONTAINER_ID',
  INITIALIZE_GTM: 'gtm/INITIALIZE_GTM',
};

interface UpdateContainerAction {
  type: typeof ACTION_TYPES.UPDATE_CONTAINER_ID;
  payload: string;
}

interface InitializeGtmAction {
  type: typeof ACTION_TYPES.INITIALIZE_GTM;
  payload: boolean;
}
